import gql from "graphql-tag";

export const changePassword = gql`
  mutation UsersdataChangePassword(
    $id: JSON
    $oldPassword: String
    $newPassword: String
  ) {
    UsersdataChangePassword(
      id: $id
      oldPassword: $oldPassword
      newPassword: $newPassword
    )
  }
`;
